import React from "react";
import { PolicyUnderwritingReadDto } from "../../../model/PolicyUnderwritingReadDto";
import { CustomerPolicyDetailLabels as cstPolicyUnderwritingLabel } from '../../../../shared/util/label';
import { Column, Row } from "../../../../components";
import "./CustomerPolicyUnderwriting.scss";
import moment from "moment";

export interface ICustomerPolicyUnderwriting {
    policyUnderwriting: PolicyUnderwritingReadDto;
}

const CustomerPolicyUnderwriting: React.FunctionComponent<ICustomerPolicyUnderwriting> = (props) => {
    const policyUnderwritingDetail = props.policyUnderwriting;
    const dateFormat = "MM/DD/YYYY"

    const labelsAndValues = [
        { label: cstPolicyUnderwritingLabel.MARKET_VALUE, value: policyUnderwritingDetail?.marketValue || null },
        { label: cstPolicyUnderwritingLabel.YEAR_BUILT, value: policyUnderwritingDetail?.yearBuilt || null },
        { label: cstPolicyUnderwritingLabel.OCCUPANCY, value: policyUnderwritingDetail?.occupancyTypeValue || null },
        { label: cstPolicyUnderwritingLabel.RESIDENCETYPE_USAGE, value: policyUnderwritingDetail?.residenceTypeValue || null },
        { label: cstPolicyUnderwritingLabel.TOTAL_SQ_FT, value: policyUnderwritingDetail?.totalSqFt || null },
        { label: cstPolicyUnderwritingLabel.HOUSEKEEPING, value: "Coming Soon" },
        { label: cstPolicyUnderwritingLabel.PURCHASE_PRICE, value: policyUnderwritingDetail?.purchasePrice || null },
        { label: cstPolicyUnderwritingLabel.PURCHASE_DATE, value: policyUnderwritingDetail?.purchaseDate ? `${moment(policyUnderwritingDetail?.purchaseDate).format(dateFormat)}` : null },
        { label: cstPolicyUnderwritingLabel.CONSTRUCTION_TYPE, value: policyUnderwritingDetail?.constructionTypeValue || null },
        { label: cstPolicyUnderwritingLabel.ROOF_MATERIAL, value: policyUnderwritingDetail?.roofMaterialTypeValue || null },
        { label: cstPolicyUnderwritingLabel.FOUNDATION, value: policyUnderwritingDetail?.foundationTypeValue || null },
        { label: cstPolicyUnderwritingLabel.SPRINKLER, value: policyUnderwritingDetail?.sprinklerTypeValue || null },
        { label: cstPolicyUnderwritingLabel.DWELLING_COVERAGE, value: policyUnderwritingDetail?.dwellingconditionTypeValue || null },
        { label: cstPolicyUnderwritingLabel.Date_Inspected, value: policyUnderwritingDetail?.dateInspected ? `${moment(policyUnderwritingDetail?.dateInspected).format(dateFormat)}` : null },
        { label: cstPolicyUnderwritingLabel.PROTECTION_CLASS, value: policyUnderwritingDetail?.protectionClass || null },
        { label: cstPolicyUnderwritingLabel.Wind_Class, value: "Coming Soon" },
        { label: cstPolicyUnderwritingLabel.Storm_Shutters, value: policyUnderwritingDetail?.stormShutterTypeValue || null },
        { label: cstPolicyUnderwritingLabel.Structure, value: "Coming Soon" },
        { label: cstPolicyUnderwritingLabel.Heat_Type, value: policyUnderwritingDetail?.heatTypeValue || null },
        { label: cstPolicyUnderwritingLabel.No_of_Bathrooms, value: "Coming Soon" },
        { label: cstPolicyUnderwritingLabel.NO_OF_ROOMS, value: policyUnderwritingDetail?.numberOfRooms || null },
        { label: cstPolicyUnderwritingLabel.Condition, value: "Coming soon" },
        { label: cstPolicyUnderwritingLabel.Basement, value: "Coming soon" },
        { label: cstPolicyUnderwritingLabel.Dwelling_Loc, value: policyUnderwritingDetail?.dwellingLocTypeValue || null },
        { label: cstPolicyUnderwritingLabel.Secondary_Heat, value: policyUnderwritingDetail?.secondaryHeatTypeValue || null },
        { label: cstPolicyUnderwritingLabel.No_of_Stories, value: policyUnderwritingDetail?.numberOfStories || null },
        { label: cstPolicyUnderwritingLabel.Years_Occupied, value: policyUnderwritingDetail?.yearOccupied || null },
        { label: cstPolicyUnderwritingLabel.Oil_Storage, value: "Coming soon" },
        { label: cstPolicyUnderwritingLabel.Swimming_Pool, value: policyUnderwritingDetail?.isSwimPool ? "Yes" : policyUnderwritingDetail?.isSwimPool === false ? "No" : null },
        { label: cstPolicyUnderwritingLabel.Pet, value: "Coming soon" },
    ];
    
    const rows = [];
    for (let i = 0; i < labelsAndValues.length; i += 6) {
        rows.push(labelsAndValues.slice(i, i + 6));
    }

    return (
        <div className="policy-underwriting-container">
            <h5 className="underwriting-title">{cstPolicyUnderwritingLabel.UNDERWRITING_INFORMATION}</h5> 
            {rows.map((row, rowIndex) => (
                <Row key={`row-${rowIndex}`} className="underwriting-row">
                    {row.map((item, colIndex) => (
                        <Column key={`col-${rowIndex}-${colIndex}`} lg={2}  className="underwriting-column">
                            <div className="underwriting-label">
                                {item.label}
                            </div>
                            <div className="underwriting-value">
                                {item.value || <>&nbsp;</>}
                            </div>
                        </Column>
                    ))}
                </Row>
            ))}
        </div>
    );
};

export default CustomerPolicyUnderwriting;
